import {AbstractControl, ValidatorFn} from '@angular/forms';

import {OtpInvalidLengthKey, OtpInvalidSymbolKey} from './custom-validator-keys';

export function PhoneOtpValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
        const value = control.value;

        if (!value) {
            return {[OtpInvalidLengthKey]: true};
        }

        if (!value.match(/^\d{6}$/)) {
            return {[OtpInvalidLengthKey]: true};
        }

        if (value.replace(/[0-9]+/g, '').length > 0) {
            return {[OtpInvalidSymbolKey]: true};
        }

        return null;
    };
}
